import Immutable from 'immutable';

export function get(key) {
    return Immutable.fromJS(JSON.parse(localStorage.getItem(key)));
}

export function set(key, value) {
    const data = Immutable.Iterable.isIterable(value)
        ? value.toJS()
        : value;
    localStorage.setItem(key, JSON.stringify(data));
}

export default { get, set };
